import React, { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';

const FileUpload = ({ onFilesSelected, newFile }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    onFilesSelected(files);
  };

  const handleNewFile = () => {
    newFile();
  };

  return (
    <div className="fileUploadContainer" style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ width: '100%', padding: '5px 10px' }}>
        <label onClick={handleNewFile} className="fileUploadButton" style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '10px' }}>
          New File
          <span style={{ flexGrow: 1 }}></span>
          <AddIcon />
        </label>
      </div>
      <div style={{ width: '100%', padding: '5px 10px' }}>
        <label htmlFor="file-upload" className="fileUploadButton" style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '10px' }}>
          Import Files
          <span style={{ flexGrow: 1 }}></span>
          <DownloadIcon />
        </label>
      </div>
      <input
        id="file-upload"
        type="file"
        multiple
        onChange={handleFileChange}
        className="fileInput"
      />
    </div>
  );
};

export default FileUpload;